import React from 'react';
import cx from 'classnames';
import { PropTypes } from 'prop-types';
import { Link } from 'react-router-dom';
import { usePopulate } from '../../api/ApiHooks';
import Card from '../Card';
import LineItem from '../../pages/builder/LineItem';
import formatShortDate from './formatShortDate';
import Spend from './Spend';
import CaseStatus from './CaseStatus';
var AuthorizationSpendCard = function AuthorizationSpendCard(_ref) {
  var item = _ref.item,
    unit = _ref.unit,
    isAuthorized = _ref.isAuthorized,
    isCostBased = _ref.isCostBased,
    isCurrentItem = _ref.isCurrentItem,
    fieldClassName = _ref.fieldClassName,
    cardClassName = _ref.cardClassName,
    enabledLink = _ref.enabledLink,
    valueClassName = _ref.valueClassName;
  usePopulate('fee_schedule_program', 'fee_schedule_program', item, {
    placeholderData: undefined
  });
  var isAutoApproved = item.auto_approved;
  var programName = item.fee_schedule_program.name;
  var requestText = "Request #".concat(item.short_id);
  var requestLink = /*#__PURE__*/React.createElement(Link, {
    to: "/authorizations/".concat(item.id)
  }, requestText);
  var createdDate = formatShortDate(item.created_at);
  var updatedDate = formatShortDate(item.updated_at);
  var startDate = formatShortDate(item.service_starts_at);
  var endDate = formatShortDate(item.service_ends_at);
  var caseOpenedDate = item !== null && item !== void 0 && item.case_opened_date ? formatShortDate(item.case_opened_date) : '';
  var caseClosedDate = item !== null && item !== void 0 && item.case_closed_date ? formatShortDate(item.case_closed_date) : '';
  var requestId = !isCurrentItem && enabledLink ? requestLink : requestText;
  return /*#__PURE__*/React.createElement(Card, {
    className: cx(cardClassName, isCurrentItem && 'bg-light-border-grey')
  }, isCurrentItem && /*#__PURE__*/React.createElement("div", {
    className: "italic pt-4 px-4"
  }, "This is the request you are currently viewing."), programName && !isCurrentItem && /*#__PURE__*/React.createElement("div", {
    className: "font-bold pt-4 px-4"
  }, "Referral for ", programName), /*#__PURE__*/React.createElement("dl", {
    className: "grid grid-cols-2 gap-y-1 gap-x-2 py-3 px-4 m-0"
  }, /*#__PURE__*/React.createElement(LineItem, {
    fieldClassName: fieldClassName,
    field: requestId,
    dataTestElement: "request-short-id",
    valueClassName: valueClassName
  }, isAuthorized ? "".concat(isAutoApproved ? 'Auto ' : '', "Accepted on ").concat(updatedDate) : "Open since ".concat(createdDate)), /*#__PURE__*/React.createElement(LineItem, {
    fieldClassName: fieldClassName,
    field: isAuthorized ? 'Authorized Amount' : 'Amount Requested',
    "data-test-element": "request-amount",
    valueClassName: valueClassName
  }, /*#__PURE__*/React.createElement(Spend, {
    isCostBased: isCostBased,
    amount: item.spend,
    unit: unit
  })), /*#__PURE__*/React.createElement(LineItem, {
    fieldClassName: fieldClassName,
    field: isAuthorized ? 'Authorized Service Period' : 'Requested Service Dates',
    dataTestElement: "service-period",
    valueClassName: valueClassName
  }, startDate, " - ", endDate), /*#__PURE__*/React.createElement(LineItem, {
    fieldClassName: fieldClassName,
    field: isAuthorized ? 'Case Status' : 'Requester',
    dataTestElement: "case-status",
    valueClassName: valueClassName
  }, isAuthorized ? /*#__PURE__*/React.createElement(CaseStatus, {
    state: item.case_state,
    openedDate: caseOpenedDate,
    closedDate: caseClosedDate
  }) : item.requester_name)));
};
AuthorizationSpendCard.propTypes = {
  item: PropTypes.shape({
    auto_approved: PropTypes.bool.isRequired,
    case_opened_date: PropTypes.string.isRequired,
    case_closed_date: PropTypes.string.isRequired,
    case_state: PropTypes.string.isRequired,
    created_at: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
    fee_schedule_program: PropTypes.shape({
      name: PropTypes.string.isRequired
    }),
    requester_name: PropTypes.string.isRequired,
    service_starts_at: PropTypes.string.isRequired,
    service_ends_at: PropTypes.string.isRequired,
    short_id: PropTypes.string.isRequired,
    state: PropTypes.string.isRequired,
    spend: PropTypes.number.isRequired,
    updated_at: PropTypes.string.isRequired
  }).isRequired,
  isCostBased: PropTypes.bool.isRequired,
  unit: PropTypes.string.isRequired,
  isAuthorized: PropTypes.bool.isRequired,
  isCurrentItem: PropTypes.bool,
  fieldClassName: PropTypes.string,
  cardClassName: PropTypes.string,
  valueClassName: PropTypes.string,
  enabledLink: PropTypes.bool
};
AuthorizationSpendCard.defaultProps = {
  isCurrentItem: false,
  fieldClassName: 'text-brand-blue text-sm leading-5 ml-0',
  cardClassName: '',
  valueClassName: 'text-brand-blue text-sm leading-5 ml-0',
  enabledLink: false
};
export default AuthorizationSpendCard;
//# sourceMappingURL=AuthorizationSpendCard.js.map